import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './ImportantCard.scss';

const ImportantCard = ({ title, children }) => (
  <div className="streaming streaming__important mb__0">
    <label className="streaming__important__title">
      <FontAwesomeIcon className="_mr-2" icon={['fas', 'info-circle']} />
      <I18n label={title} />
    </label>
    {children}
  </div>
);

ImportantCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default ImportantCard;
